/**
 * @generated SignedSource<<2eca449ae9c28db0676a2559665d91cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LabelKind = "admin_experience" | "admin_member" | "assignment" | "curriculum" | "custom" | "experience" | "lesson" | "organization" | "organization_admin" | "organization_member" | "organization_owner" | "pathway" | "product_admin" | "product_instructor" | "product_member" | "quiz" | "sidebar_community" | "sidebar_product" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LabelsContextActiveOrganizationFragment$data = {
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string;
        readonly id: string;
        readonly kind: LabelKind;
        readonly plural: string;
        readonly singular: string;
      };
    }>;
  };
  readonly " $fragmentType": "LabelsContextActiveOrganizationFragment";
};
export type LabelsContextActiveOrganizationFragment$key = {
  readonly " $data"?: LabelsContextActiveOrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelsContextActiveOrganizationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LabelsContextActiveOrganizationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelNodeConnection",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "singular",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "plural",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "a90e3bf0bcec64ca23ae262a7e27f56c";

export default node;
